import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { softwareCapacityEmbedRoute } from '@atlassian/jira-router-routes-software-capacity-routes/src/softwareCapacityEmbedRoute.tsx';
import { CapacityEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { capacityRouteEntry } from './common/capacityRouteEntry.tsx';

export const softwareCapacityEmbedRouteEntry = createEntry(softwareCapacityEmbedRoute, () => ({
	group: 'software',
	skeleton: CapacityEmbedSkeleton,
	component: CapacityEmbedSkeleton,

	entryPoint() {
		if (__SERVER__) {
			return undefined;
		}
		return capacityRouteEntry;
	},

	layout: chromelessLayout,

	resources: [
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticSidebarShortcutsResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...jiraSpaResources(),
	],

	ufoName: 'next-gen-capacity-embed',

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-software-capacity-entries/src/softwareCapacityEmbedRouteEntry.tsx',
			whichExportToUse: 'softwareCapacityEmbedRouteEntry',
		},

		enabled: true,
	},
}));
